// extracted by mini-css-extract-plugin
export default {"downloadButton":"u2k4H___MediaDownloader-module__downloadButton"};